<template>
  <v-container>
    <v-content>
      <h1 class="text-center primary--text pt-4">
        Nutzerverwaltung
      </h1>
    </v-content>
    <v-row cols="12">
      <v-col cols="12" sm="12">
        <UserTable></UserTable>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UserTable from '../components/tables/UserTable'

export default {
  components: {
    UserTable
  },
  data: () => ({
    content: {}
  }),
  created: function() {},
  methods: {}
}
</script>
